{
	"title": "Transaksjonen ble ikke funnet",
	"description": "Gå til oversikten og skriv inn en gyldig transaksjons-ID. En transaksjons-ID finner du på en erklæring eller på en faktura.",
	"secondaryButtonTitle": "Vis startside"
}
